<template>
    <div class="type-area">
        <el-row :gutter="39" class="row">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="padding: 0 !important;">
                <div
                        class="grid-content ql-editor contactUs"
                        style="padding: 0;"
                        v-if="hxContentList[0].content"
                        v-html="hxContentList[0].content"
                ></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="padding: 0 !important;" class="col">
                <div class="grid-content">
                    <el-form
                            :model="form"
                            :rules="rules"
                            ref="form"
                            label-width="60px"
                    >
                        <el-form-item label="昵称" prop="nickName">
                            <el-input style="width: 100%;" class="input" v-model="form.nickName"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email">
                            <el-input style="width: 100%;" class="input" v-model="form.email"></el-input>
                        </el-form-item>
                        <el-form-item label="手机" prop="phone">
                            <el-input style="width: 100%;" class="input" v-model="form.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="content">
                            <el-input
                                    style="width: 100%;"
                                    class="input"
                                    v-model="form.content"
                                    type="textarea"
                                    :rows="5"
                                    placeholder="请输入内容"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm()"
                            >提交
                            </el-button
                            >
                            <el-button @click="resetForm('form')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {addRelate} from "@/api/relate";

    export default {
        name: "contact-us-index",
        props:{
            hxContentList:Array
        },
        data(){
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("手机号不能为空"));
                } else {
                    const reg = /^1[3-9][0-9]\d{8}$/;
                    // 这里定义的reg变量没有加引号，所以是一种特殊的数据类型，即正则，可以直接用test()方法
                    if (reg.test(value)) {
                        callback();
                    } else {
                        // 具体错误信息没有提示
                        return callback(new Error("请输入正确的手机号"));
                    }
                }
            };
            return{
                form: {
                    nickName: null,
                    email: null,
                    phone: null,
                    content: null,
                },
                rules: {
                    nickName: [{required: true, message: "请输入昵称", trigger: "blur"}],
                    email: [
                        {required: true, message: "请输入邮箱地址", trigger: "blur"},
                        {
                            type: "email",
                            message: "请输入正确的邮箱地址",
                            trigger: ["blur", "change"],
                        },
                    ],
                    phone: [
                        {
                            required: true,
                            min: 11,
                            message: "手机号不足11位",
                            trigger: "blur",
                        },
                        {validator: checkPhone, trigger: "blur"},
                    ],
                },
            }
        },
        methods:{
            // 重置表单
            resetForm() {
                this.$refs['form'].resetFields();
            },
            // 提交表单
            submitForm() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        addRelate(this.form).then((response) => {
                            console.log(response)
                            this.$message({
                                message: "提交成功",
                                type: "success",
                            });
                            this.$refs['form'].resetFields();
                        });
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .contactUs {
        color: #333;
    }
    @media screen and (min-width: 1400px) {
        .type-area {
            width: 80%;
            margin: 0 auto;
        }
    }

    @media screen and (min-width: 1200px) {
        .row{
            margin: 0 20px !important;
        }
    }

    @media screen and (max-width: 1200px) {
        .type-area{
            width: 100%;
            margin: 0 auto;
        }
    }

    @media screen and (max-width: 870px) {
        .type-area{
            width: 100%;
            margin: 0 auto;
        }

        .row{
            margin: 0 20px !important;
        }

        .col{
            margin-top: 20px;
        }
    }

    @media screen and (max-width: 570px) {
        .type-area{
            width: 100%;
            margin: 0 auto;
        }

        .row{
            margin: 0 20px !important;
        }

        .col{
            margin-top: 20px;
        }
    }
</style>
